import PropTypes from 'prop-types';

const expenseTypesType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
});

export default expenseTypesType;
